import React from 'react';
import { Link } from 'react-router-dom';

function Hero() {
  return (
    <section className="bg-fondo-claro flex justify-center items-center py-[80px] px-5 max-md:py-[40px] max-md:px-0">
      <div className="bg-white w-full text-center max-w-[900px] py-[50px] px-[60px] rounded-[20px] shadow-[0_10px_40px_rgba(0,0,0,0.08)] border-t-[5px] border-icetex max-md:py-[30px] max-md:px-[25px] max-md:border-t-0 max-md:w-[90%] max-md:mx-auto">
        <h1 className="text-texto-oscuro font-extrabold text-[3rem] mb-6 leading-[1.3] max-md:text-[1.6rem] max-md:mb-4">
          Bienvenido a Cursos Virtuales ICETEX: Un espacio para tu bienestar, tu plan y propósito de vida
        </h1>
        <p className="text-texto-sec text-[1.1rem] mb-10 leading-[1.7] max-md:text-[0.95rem] max-md:mb-8">
          Aquí encontrarás diagnósticos, formación y acompañamiento para fortalecer tu bienestar emocional y tu proyecto personal.
        </p>
        <Link
          to="/diagnosticos"
          className="cta-button bg-icetex text-white border-0 uppercase font-bold cursor-pointer no-underline inline-block py-[18px] px-[40px] rounded-[50px] text-base tracking-[0.5px] shadow-[0_4px_20px_rgba(0,63,129,0.35)] transition-all duration-300 hover:text-white hover:bg-texto-oscuro hover:-translate-y-[3px] hover:shadow-[0_6px_25px_rgba(21,24,67,0.4)] max-md:py-[15px] max-md:px-[30px] max-md:text-[0.9rem]"
        >
          Haz tu primer diagnóstico
        </Link>
      </div>
    </section>
  );
}

export default Hero;
